import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserApiService } from 'src/app/user-api.service';

@Component({
  selector: 'app-cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.css']
})
export class CookieDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<CookieDialogComponent>, private userService : UserApiService) { 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
  }

  OkData() {
    this.userService.validateRGPD();
    this.dialogRef.close();
  }
}
